import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";

type Props = {
  hasFiltersApplied: boolean;
  onClearFilters: () => void;
};

export function NoReceivablesEmptyState({ hasFiltersApplied, onClearFilters }: Props) {
  return (
    <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ minHeight: 280, px: 2, textAlign: "center" }}>
      <Typography variant="h6" color="text.secondary">
        No receivables
      </Typography>
      {hasFiltersApplied && (
        <>
          <Typography variant="body2" color="text.secondary">
            Try clearing your filters to see more receivables.
          </Typography>
          <Button variant="outlined" onClick={onClearFilters} component="button">
            Clear filters
          </Button>
        </>
      )}
      {!hasFiltersApplied && (
        <Button variant="outlined" component={Link} to="/chasables">
          Back to receivables
        </Button>
      )}
    </Stack>
  );
}
